import { Pipe, PipeTransform } from '@angular/core';

import {
  ESalesOrderSource,
  ESalesOrderStatus,
  ISalesOrder,
} from 'v2/modules/order/interfaces/order.interface';

@Pipe({
  name: 'canEditSalesOrderItems',
  standalone: true,
})
export class CanEditSalesOrderItemsPipe implements PipeTransform {
  transform(salesOrder :ISalesOrder) :boolean {
    
    if (!salesOrder) {
      return true;
    }

    const status = salesOrder.orderStatus;
    // Check if the sales order is in PENDING status
    if (status === ESalesOrderStatus.PENDING) {
      // Check if the sales order is created from Luminous or Sales Order
      const canEditSalesOrderSource = [
        ESalesOrderSource.LUMINOUS,
        ESalesOrderSource.SALES_ORDER,
      ];

      if (
        canEditSalesOrderSource.includes(salesOrder.source as ESalesOrderSource)
      ) {
        return true;
      }

      return false;
    }

    return false;
  }
}
